export default __webpack_public_path__ + "static/media/help.7d383cea.svg";